export default {"src":"/_next/static/media/quiz-start.83eaf80d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};